import { AppName } from "@src/config/constants";

export const headTitle = (title?: string): string => {
  if (!title) return AppName;
  return `${title} | ${AppName}`;
};
